var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60293_43625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7818 5.06093L7.99775 8.97775L1.21094 5.05469",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 8.97656V12.6164V16.2561",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8058 16.6002C8.30529 16.8892 7.68863 16.8892 7.18812 16.6002L1.80103 13.49C1.30051 13.201 0.992188 12.6669 0.992188 12.089V5.86855C0.992188 5.29061 1.30051 4.75657 1.80103 4.4676L7.18812 1.35736C7.68863 1.06838 8.30529 1.06838 8.8058 1.35736L14.1929 4.4676C14.5151 4.65362 14.7577 4.94119 14.8896 5.27665C14.9223 5.35972 14.9482 5.44572 14.9668 5.53385",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7194 13.8794L10.1094 11.4944L12.7194 9.10938",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8828 11.2734H14.2302C14.5756 11.2734 14.9175 11.3444 15.2366 11.4824C15.5556 11.6203 15.8455 11.8225 16.0897 12.0774C16.3339 12.3323 16.5276 12.6349 16.6598 12.968C16.7919 13.301 16.8599 13.658 16.8599 14.0184C16.8599 14.3789 16.7919 14.7359 16.6598 15.0689C16.5276 15.4019 16.3339 15.7045 16.0897 15.9594C15.8455 16.2143 15.5556 16.4165 15.2366 16.5545C14.9175 16.6924 14.5756 16.7634 14.2302 16.7634H12.5568",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60293_43625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.53e6962c2924111bf8278e0ca92cc6ca.svg";
export { ForwardRef as ReactComponent };